var _defs, _g, _path, _line, _line2, _path2, _line3, _line4, _path3, _line5, _line6, _path4, _line7, _line8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTreat7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 82.99 92.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#636255;}.cls-2{fill:none;stroke:#636255;stroke-linecap:round;stroke-miterlimit:10;stroke-width:3px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Treat2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    className: "cls-1",
    d: "M42.1,92.93h-.6q-.64,0-1.29,0c-6.62-.2-13.23-3.66-19.1-10a50.4,50.4,0,0,1-10.7-18.36c-.14-.42-.24-.84-.34-1.25a9.16,9.16,0,0,1-6.86-4.8A28.27,28.27,0,0,1,0,45.1c0-4,1.88-6.47,5.59-7.4-.1-.57-.19-1.15-.27-1.73-1.05-8.1.44-14.71,4.54-20.19C17.16,6,27.46.86,41.33,0h.33C55.54.86,65.83,6,73.13,15.78c4.1,5.49,5.59,12.09,4.54,20.19q-.12.87-.27,1.74c3.72.93,5.59,3.41,5.59,7.39a28.27,28.27,0,0,1-3.21,13.4,9.16,9.16,0,0,1-6.86,4.8c-.1.41-.2.83-.34,1.26a50.36,50.36,0,0,1-10.7,18.35c-5.87,6.35-12.48,9.82-19.1,10Zm-.6-5.39h1.11C54.46,87.19,64.44,72.67,67.45,63c.16-.53.29-1.12.42-1.75.07-.33.14-.66.22-1l.47-2,2.08-.06C73.53,58.05,74.46,57,75,56a22.94,22.94,0,0,0,2.57-10.87c0-1.59-.22-2-2.28-2.31-.4-.06-.8-.14-1.14-.2l-.39-.08L71.23,42l.42-2.59c.09-.53.18-1,.26-1.53.17-.91.32-1.78.43-2.61.85-6.64-.29-12-3.51-16.27C62.56,10.62,53.61,6.16,41.49,5.39,29.37,6.16,20.43,10.62,14.16,19c-3.22,4.31-4.37,9.63-3.51,16.28.11.83.26,1.7.42,2.62.08.49.17,1,.26,1.52L11.75,42l-2.57.49-.38.07c-.35.07-.75.16-1.17.21-2,.29-2.26.73-2.26,2.32A22.79,22.79,0,0,0,8,56c.58,1.08,1.51,2.09,4.4,2.17l2.08.06.47,2,.21,1c.14.63.26,1.22.42,1.75,3,9.71,13,24.23,24.84,24.59.35,0,.69,0,1,0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    className: "cls-1",
    d: "M50.91,73.39a17.17,17.17,0,0,0-7.58-2.48A21.29,21.29,0,0,0,33,73.26a2.32,2.32,0,0,0-1.25,1.25,1.63,1.63,0,0,0,.17,1.28,1.81,1.81,0,0,0,2.46.72l.17-.1c5.09-2.62,10-2.6,14.66,0a2,2,0,0,0,1,.28,1.69,1.69,0,0,0,1.47-.85,1.72,1.72,0,0,0,.22-1.31A2,2,0,0,0,50.91,73.39Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    "data-name": "Path 308",
    className: "cls-1",
    d: "M36.46,63.09A6.15,6.15,0,0,0,41.68,66h0a6.23,6.23,0,0,0,5.63-3.13,1.72,1.72,0,0,0-.45-2.4h0a1.69,1.69,0,0,0-2.36.44l0,.06c-1.5,1.92-3.63,2-5.14.07A1.72,1.72,0,0,0,37,60.42l-.12.07A1.78,1.78,0,0,0,36.37,63Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    className: "cls-1",
    d: "M18.45,44.45a19.5,19.5,0,0,1,8.88-.72,18.34,18.34,0,0,1,2.62.68,13.61,13.61,0,0,0,4.1.84,6.72,6.72,0,0,0,1.26-.12,2.15,2.15,0,0,0,1.76-1.32A1.74,1.74,0,0,0,36.51,42,4.66,4.66,0,0,0,34,41l-2.46-.48a38.82,38.82,0,0,0-7.59-1q-.9,0-1.8.09A7.65,7.65,0,0,0,18.43,41c-.88.59-1.79,1.3-1.82,2.2a1.36,1.36,0,0,0,.55,1.12A1.41,1.41,0,0,0,18.45,44.45Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    "data-name": "Path 310",
    className: "cls-1",
    d: "M33.73,51.41a8.32,8.32,0,0,1,1.3-.19,1.06,1.06,0,0,0,.15-2.09,18,18,0,0,0-3.81-.37c-1.25,0-2.49.09-3.69.17L26.34,49a13.69,13.69,0,0,1-7.65-1.63l-.16-.07-.24,0a.9.9,0,0,0-.91.9,1,1,0,0,0,.31.69c.21.18.41.38.64.6a10.27,10.27,0,0,0,1.37,1.18l.3.2a12.24,12.24,0,0,0,2.13,1,15.93,15.93,0,0,0,4.42.94c.54,0,1.09.07,1.64.07a9.21,9.21,0,0,0,3-.43,11.27,11.27,0,0,0,1.24-.53A7,7,0,0,1,33.73,51.41Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    className: "cls-1",
    d: "M65.89,41a7.61,7.61,0,0,0-3.7-1.42,17.78,17.78,0,0,0-1.8-.09,38.58,38.58,0,0,0-7.63,1L50.34,41A4.66,4.66,0,0,0,47.81,42a1.75,1.75,0,0,0-.56,1.79A2.17,2.17,0,0,0,49,45.13a6.75,6.75,0,0,0,1.27.12,13.74,13.74,0,0,0,4.1-.84A17.87,17.87,0,0,1,57,43.73a19.5,19.5,0,0,1,8.88.72,1.81,1.81,0,0,0,.51.08,1.27,1.27,0,0,0,.78-.25,1.35,1.35,0,0,0,.56-1.12C67.68,42.26,66.78,41.54,65.89,41Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    className: "cls-1",
    d: "M66,47.3h0l-.18,0-.22.09A13.71,13.71,0,0,1,58,49l-1.34-.09c-1.2-.08-2.44-.17-3.69-.17a17.4,17.4,0,0,0-3.81.37,1.06,1.06,0,0,0,.14,2.09,8.27,8.27,0,0,1,1.31.19,6.4,6.4,0,0,1,1.33.54,10.9,10.9,0,0,0,1.22.52,9.18,9.18,0,0,0,3,.43c.55,0,1.1,0,1.64-.07a15.78,15.78,0,0,0,4.41-.94,11.91,11.91,0,0,0,2.13-1l.3-.19A9.5,9.5,0,0,0,66,49.47c.2-.2.4-.4.62-.58A.91.91,0,0,0,66,47.3Z",
    transform: "translate(0 0)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.13,38.7A21.89,21.89,0,0,0,19,26.19",
    transform: "translate(0 0)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 18.88,
    y1: 25.89,
    x2: 21.48,
    y2: 30.89
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 25.26,
    y1: 23.07,
    x2: 19.04,
    y2: 25.67
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M47.19,38.7a21.89,21.89,0,0,1,18.1-12.51",
    transform: "translate(0 0)"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 65.44,
    y1: 25.89,
    x2: 62.84,
    y2: 30.89
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 59.06,
    y1: 23.07,
    x2: 65.28,
    y2: 25.67
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32,55.36a12.06,12.06,0,0,1-5.52,4.17,12.19,12.19,0,0,1-6.85.41",
    transform: "translate(0 0)"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 19.49,
    y1: 60.1,
    x2: 21.67,
    y2: 57.4
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 22.95,
    y1: 63.09,
    x2: 19.56,
    y2: 60.27
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51.38,55.36a12.06,12.06,0,0,0,5.52,4.17,12.19,12.19,0,0,0,6.85.41",
    transform: "translate(0 0)"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 63.87,
    y1: 60.1,
    x2: 61.7,
    y2: 57.4
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 60.42,
    y1: 63.09,
    x2: 63.81,
    y2: 60.27
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreat7);
export default __webpack_public_path__ + "static/media/Treat7.0033e1e5e3931ae65cdd4ba36f7201e4.svg";
export { ForwardRef as ReactComponent };